import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientDashboardServices = createAsyncThunk("client/dashboard-services", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/dashboard-services`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    return res.data.clientServices;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client services");
  }
});

export const getAppointmentNotesDashboard = createAsyncThunk(
  "client/appointment-notes",
  async ({ token, serviceId }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/client/get-appointment-notes-dashboard/${serviceId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch notes"
      );
    }
  }
);

const clientDashboardSlice = createSlice({
    name: "clientDashboard",
        initialState: {
          clientsServices: null,
          loading: false,
          error: null,
          appointmentNotes: [],
          aiReport: null,
          noAppointment: false,
          loadingNotes: false,
        },
        extraReducers: (builder) => {
          builder
            .addCase(getClientDashboardServices.pending, (state) => {
                state.loading = true;
            })
            .addCase(getClientDashboardServices.fulfilled, (state, action) => {
                state.clientsServices = action.payload;
                state.loading = false;
            })
            .addCase(getClientDashboardServices.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch client services"; 
                state.loading = false;
            })
            .addCase(getAppointmentNotesDashboard.pending, (state) => {
              state.loadingNotes = true;
              state.aiReport = null;
              state.appointmentNotes = [];
              state.noAppointment = false;
            })
            .addCase(getAppointmentNotesDashboard.fulfilled, (state, action) => {
              const res = action.payload;

              if (Array.isArray(res.providerAppointment)) {
                state.appointmentNotes = res.providerAppointment;
                state.noAppointment = true;
              } else if (res.data) {
                state.aiReport = res.data;
                state.noAppointment = false;
              }

              state.loadingNotes = false;
            })
            .addCase(getAppointmentNotesDashboard.rejected, (state, action) => {
              state.loadingNotes = false;
              state.error = action.payload;
            });
    },
});

export default clientDashboardSlice.reducer;